import React, { Component } from 'react';
import { List, Modal, Toast } from 'antd-mobile';
import F2 from '@antv/f2';
import df from 'dateformat';
import { ROOT_PATH } from '../../config';
import qs from 'qs';
import Table from '../../components/Table';
import axios from 'axios';
import { FARM_ORG, ORG_CODE, TOKEN } from '../../cache';
import SwineDetails from './fpDetails';
import RangeDatePicker from '../../components/RangeDatePicker';
import EmptyReport from '../../components/EmptyReport';

const today = new Date();
let width = document.documentElement.clientWidth;

class Farrow19WK extends Component {
  constructor(props) {
    super(props);
    const _self = this;
    this.state = {
      noData: false, // false表示有数据，true 表示无数据
      startDate: new Date(new Date().setDate(1)),
      endDate: new Date(),
      modalShow: false,
      modalHeader: '',
      modalContent: null,
      date: today,
      data1: [
        /*   {
          'aliveAvg': 8.38,//窝均健仔数
          'bornAvg': 9.38,//窝均产仔数
          'damageAvg': 1,//窝均损失数
          'farrowQty': 13, //分娩窝数
          'parity': 1, //胎次
          'weakAvg': 0//窝均弱仔数
        }*/
      ],
      columns: [
        {
          id: 'col1',
          title: '胎次', //表头信息
          fixed: true, //是否为固定表头
          width: 70, //设置固定宽度
          align: 'left', //文本对齐方式 left center right
          //定制该列数据的显示格式
          render(data, index, item) {
            const { startDate, endDate } = _self.state;
            const name = item && item.col1;
            return (
              <span
                onClick={() => {
                  if (name !== '合计') {
                    _self.setState({
                      modalShow: true,
                      modalContent: <SwineDetails data={item} end={endDate} start={startDate} />
                    });
                  }
                }}
                style={{ color: name === '合计' ? '#333' : '#4A83F5' }}
              >
                {name}
              </span>
            );
          }
        },
        {
          id: 'col2',
          width: 60,
          title: '分娩窝数',
          align: 'right'
        },
        {
          id: 'col3',
          width: 60,
          title: '窝均产仔数',
          align: 'right'
        },
        {
          id: 'col4',
          width: 60,
          title: '窝均健仔数',
          align: 'right'
        },
        {
          id: 'col5',
          width: 60,
          title: '窝均弱仔数',
          align: 'right'
        },
        {
          id: 'col6',
          width: 60,
          title: '窝均损失数',
          align: 'right'
        }
      ],
      data: [],
      data3: [],
      paritys: {
        1: '1胎',
        2: '2胎',
        3: '3胎',
        4: '4胎',
        5: '5胎',
        6: '6胎',
        7: '7胎',
        8: '7胎以上',
        9: '合计'
      }
    };
  }

  getReport01 = (datas) => {
    console.log('chart', datas);
    datas.splice(8, 1);
    let data = [];
    let obj = {
      bornAvg: '窝均产仔数',
      aliveAvg: '窝均健仔数',
      weakAvg: '窝均弱仔数',
      damageAvg: '窝均损失数'
    };
    let arr = Object.keys(obj);
    arr.forEach((type) => {
      datas.forEach((d) => {
        data.push({
          type,
          value: d[type],
          xName: d['parity']
        });
      });
    });
    console.log(data);
    let chart = this.chart1;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'myChart1',
        padding: ['auto', 30, 30, 'auto'],
        pixelRatio: window.devicePixelRatio
      });
    }
    this.chart1 = chart;
    chart.source(data, {
      xName: {
        formatter: function formatter(val) {
          return val === 8 ? '7胎以上' : val + '胎';
        }
      },
      value: {
        tickCount: 5,
        formatter: function formatter(ivalue) {
          return ivalue;
        }
      }
    });
    chart.axis('xName', {
      line: null,
      nice: false,
      tickLine: {
        lineWidth: 1,
        stroke: '#ccc',
        length: 5 // 刻度线长度
      }
    });
    chart.legend({
      position: 'top',
      align: 'center',
      offsetY: 5,
      marker: function(x, y, r, ctx) {
        ctx.lineWidth = 1;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.moveTo(x - r - 3, y);
        ctx.lineTo(x + r + 3, y);
        ctx.stroke();
        ctx.arc(x, y, r, 0, Math.PI * 2, false);
        ctx.fill();
      },
      itemFormatter: function(text) {
        return obj[text];
      }
    });
    chart.tooltip({
      showTitle: true,
      showCrosshairs: true,
      showItemMarker: true,
      offsetY: 45,
      tooltipMarkerStyle: {
        fill: '#fff' // 设置 tooltipMarker 的样式
      },
      background: {
        radius: 6,
        padding: [6, 10]
      },
      onShow: function onShow(ev) {
        var items = ev.items;
        // ev.tooltipMarkerCfg.type = 'rect'
        items.map((item) => {
          item.name = obj[item.origin.type];
          item.value = [item.origin.value] + '头';
        });
      }
    });
    chart
      .line()
      .position('xName*value')
      .color('type', ['#1890FF', '#FE5578', '#F5E200', '#8D43D6'])
      .shape('smooth');
    chart
      .point()
      .position('xName*value')
      .size(3)
      .color('type', ['#1890FF', '#FE5578', '#F5E200', '#8D43D6']);
    chart.render();
  };
  getData1 = (a, b) => {
    Toast.loading('加载中', 0);
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/farrowPerAnalysisGraph`,
        qs.stringify({
          startDate: df(a, 'yyyy-mm-dd'),
          endDate: df(b, 'yyyy-mm-dd'),
          gd_type: 'D001401',
          gd_code: '2001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        Toast.hide();
        let data1 = res.data;
        let data = [];
        data1.map((item) => {
          data.push({
            col1: this.state.paritys[item.parity],
            col2: item.farrowQty,
            col3: item.bornAvg,
            col4: item.aliveAvg,
            col5: item.weakAvg,
            col6: item.damageAvg
          });
        });
        this.setState({
          data,
          noData: data1.length === 0
        });
        if (data1.length === 0) {
          return;
        }
        this.getReport01(data1);
      })
      .catch((execption) => {
        Toast.hide();
        console.log(execption);
      });
  };
  doSearch = (a, b) => {
    this.getData1(a, b);
  };

  componentDidMount() {
    window._czc.push(['_trackEvent', '进入母猪分胎次产仔性能分析页面']);
    this.doSearch(this.state.startDate, this.state.endDate);
  }

  render() {
    const startDate = df(this.state.startDate, 'yyyy-mm-dd');
    const endDate = df(this.state.endDate, 'yyyy-mm-dd');
    return (
      <React.Fragment>
        {/*<NavBar>分胎次产仔性能分析</NavBar>*/}
        <List>
          <List.Item
            arrow="horizontal"
            className="span-4"
            extra={`${startDate} 至 ${endDate}`}
            onClick={() => {
              this.setState({
                calendarShow: true
              });
            }}
          >
            选择日期
          </List.Item>
        </List>

        <List renderHeader={() => ''}>
          <span className="title">母猪分胎次产仔性能分析</span>
          {this.state.noData ? (
            <EmptyReport height={280} width={width} />
          ) : (
            <canvas height="360" id="myChart1" width={width} />
          )}
        </List>

        {!this.state.noData && <Table columns={this.state.columns} data={this.state.data} />}

        <Modal
          animationType="slide-up"
          maskClosable={false}
          closable
          onClose={() => {
            this.setState({
              modalShow: false
            });
          }}
          popup
          visible={this.state.modalShow}
        >
          {this.state.modalContent}
        </Modal>

        <RangeDatePicker
          defaultDate={new Date(this.state.startDate)}
          defaultValue={[new Date(this.state.startDate), new Date(this.state.endDate)]}
          onCancel={() => {
            document.getElementsByTagName('body')[0].style.overflowY = this.originbodyScrollY;
            this.setState({
              calendarShow: false
            });
          }}
          onConfirm={(startDate, endDate) => {
            document.getElementsByTagName('body')[0].style.overflowY = this.originbodyScrollY;
            this.setState({
              calendarShow: false,
              startDate,
              endDate
            });
            this.doSearch(startDate, endDate);
          }}
          visible={this.state.calendarShow}
        />
      </React.Fragment>
    );
  }
}

export default Farrow19WK;
